import * as React from 'react';

import { ThemeColor, TouchNumberField } from '@rematter/ui-web';

import { NormalizedLineItem } from '../_types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { useUIPreferences } from '~/shared/hooks';

type PercentageFieldProps = {
  lineItem: NormalizedLineItem;
  percentage: number;
  onPercentageChange: (value: number) => void;
  disabled?: boolean;
  color?: ThemeColor;
};

//
// ⚛️ ⚛️ ⚛️ PERCENTAGE FIELD ⚛️ ⚛️ ⚛️
//
export const PercentageField: React.FC<PercentageFieldProps> = ({
  percentage,
  onPercentageChange,
  disabled,
  color,
}) => {
  // Translations
  const t = useTranslations();
  const { touchModeEnabled } = useUIPreferences();

  // Callbacks
  const handleChange = React.useCallback(
    (value: number | undefined) => {
      const safe = value == null || Number.isNaN(value) ? 0 : value;
      const clamped = Math.max(0, Math.min(100, safe));
      onPercentageChange(clamped);
    },
    [onPercentageChange],
  );

  return (
    <TouchNumberField
      aria-label={t.scaleTicketPro.columns.percentage}
      isDisabled={disabled}
      value={percentage}
      onChange={handleChange}
      suffix="%"
      color={color}
      formatOptions={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }}
      touchModeEnabled={touchModeEnabled}
      className="@PercentageField"
    />
  );
};
